import { client } from "@/client";
import { defineStore } from "pinia";

export const usePackageStore = defineStore("packages", {
  state: () => ({
    loading: false,
  }),
  actions: {
    async resubmitPackage(uuid: string) {
      this.loading = true;
      client.packages.packagesResubmit({ uuid })
        .then((payload) => {
          this.loading = false;
          console.log("resubmit package", payload)
        })
        .catch((error) => {
          return error;
        })
    },
  },
});
